/**
 * storage.ts - localStorage helpers for Simon Revolutions
 */

const STORAGE_KEY_PREFIX = 'simon-revolutions:';

export const hasCompletedTutorial = (): boolean => {
  return localStorage.getItem(`${STORAGE_KEY_PREFIX}tutorial-completed`) === 'true';
};

export const isTutorialCompleted = hasCompletedTutorial; // Alias

export const markTutorialCompleted = (): void => {
  localStorage.setItem(`${STORAGE_KEY_PREFIX}tutorial-completed`, 'true');
};

export const resetTutorial = (): void => {
  localStorage.removeItem(`${STORAGE_KEY_PREFIX}tutorial-completed`);
};

export const isFirstRun = (): boolean => {
  return !hasCompletedTutorial();
};

// Chaos Tutorial
export const hasCompletedChaosTutorial = (): boolean => {
  return localStorage.getItem(`${STORAGE_KEY_PREFIX}tutorial-chaos-completed`) === 'true';
};

export const isChaosTutorialCompleted = hasCompletedChaosTutorial; // Alias

export const markChaosTutorialCompleted = (): void => {
  localStorage.setItem(`${STORAGE_KEY_PREFIX}tutorial-chaos-completed`, 'true');
};

export const isFirstRunChaos = (): boolean => {
  return !hasCompletedChaosTutorial();
};

// Rhythm Tutorial
export const hasCompletedRhythmTutorial = (): boolean => {
  return localStorage.getItem(`${STORAGE_KEY_PREFIX}tutorial-rhythm-completed`) === 'true';
};

export const isRhythmTutorialCompleted = hasCompletedRhythmTutorial; // Alias

export const markRhythmTutorialCompleted = (): void => {
  localStorage.setItem(`${STORAGE_KEY_PREFIX}tutorial-rhythm-completed`, 'true');
};

export const isFirstRunRhythm = (): boolean => {
  return !hasCompletedRhythmTutorial();
};
